var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2646 23.9356C19.2686 23.9356 23.3486 21.6576 23.3486 17.1696C23.3486 13.7016 21.0366 12.1036 17.6366 11.7296V11.2876C20.6626 10.9476 22.2606 9.24759 22.2606 6.59559C22.2606 2.48158 18.8266 0.475586 12.5026 0.475586C4.75056 0.475586 0.976562 3.70559 0.976562 8.77159V8.80558H7.77656V8.70359C7.77656 7.00359 8.38856 6.59559 11.8906 6.59559C15.2906 6.59559 15.9026 6.96959 15.9026 8.05759C15.9026 8.90759 15.4946 9.34959 14.2366 9.34959H7.94656V14.5856H14.7126C16.2086 14.5856 16.8546 14.9596 16.8546 16.0816C16.8546 17.4756 15.8346 17.8156 11.9586 17.8156C7.91256 17.8156 7.77656 17.4076 7.77656 15.7076V15.0956H0.976562V15.6396C0.976562 21.0456 4.58056 23.9356 12.2646 23.9356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.3d8390a2714ada156b6b82fef45f4569.svg";
export { ForwardRef as ReactComponent };